import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import PageTitle from '../components/pagetitle/PageTitle';
import Footer from '../components/footer/Footer';
import cover from '../assets/images/company-profile-cover.webp';

const PDF_URL = '/documents/AVR-Labs-Company-Profile.pdf';
const PDF_NAME = 'AVR-Labs-Company-Profile.pdf';

function Profile(props) {
    // Inline PDF viewers are unreliable on phones and small tablets, so those
    // get the cover with open/download actions instead of an empty frame.
    const [canEmbed, setCanEmbed] = useState(true);

    useEffect(() => {
        const check = () => setCanEmbed(window.innerWidth >= 992);
        check();
        window.addEventListener('resize', check);
        return () => window.removeEventListener('resize', check);
    }, []);

    return (
        <div className='page-about wrapper pt-6'>
            <Helmet>
                <title>Company Profile | AVR Labs</title>
                <meta name="description" content="View and download the AVR Labs company profile — our work in XR, AI, and the metaverse, and the experiences we build for brands and institutions." />
            </Helmet>

            <PageTitle title='Company Profile' />

            <section className="about">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text pd-0 center">
                                <h6 className="sub-heading"><span>AVR Labs</span></h6>
                                <h3 className="heading">Creating Tomorrow's World Today</h3>
                                <p className="mb-4">
                                    Read our company profile below, or download the full PDF to keep a copy.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 d-flex flex-wrap justify-content-center gap-3 mb-5">
                            <a
                                className="action-btn"
                                href={PDF_URL}
                                download={PDF_NAME}
                            >
                                <span>Download PDF</span>
                            </a>
                            <a
                                className="action-btn s1"
                                href={PDF_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span>Open in New Tab</span>
                            </a>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 mb-5">
                            {canEmbed ? (
                                <iframe
                                    src={`${PDF_URL}#view=Fit`}
                                    title="AVR Labs Company Profile"
                                    style={{
                                        width: '100%',
                                        height: '80vh',
                                        minHeight: '600px',
                                        border: 'none',
                                        borderRadius: '24px',
                                        background: '#282B46',
                                    }}
                                />
                            ) : (
                                <a
                                    href={PDF_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'block' }}
                                >
                                    <img
                                        src={cover}
                                        alt="AVR Labs company profile cover"
                                        style={{ width: '100%', borderRadius: '24px' }}
                                    />
                                    <p className="center mt-3 mb-0">Tap to open the full profile</p>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            <Footer />

        </div>
    );
}

export default Profile;
